export default {
  header: {
    title: 'Acquista carta regalo',
  },
  items: {
    gift_card: {
      label: 'Carta regalo',
      title: "Seleziona l'importo desiderato",
      description: 'Aggiungi la carta regalo con la quantità desiderata al carrello',
    },
    expiration: {
      label: 'Valida per 3 anni',
      title: 'Buon regalo!',
      description: 'Il destinatario può riscattare il voucher liberamente entro 3 anni.',
    },
    delivery: {
      label: 'Consegna immediata come PDF via e-mail',
      title: 'Consegna immediata come PDF via e-mail',
      description:
        'Dopo il pagamento sicuro con carta di credito, PayPal o giropay, riceverai il voucher immediatamente.',
    },
  },
  form: {
    value: {
      title: "Scegli l'importo della carta regalo",
      custom: {
        label: 'Personalizzato',
        placeholder: 'Inserisci importo',
      },
    },
    quantity: {
      title: 'Quantità',
    },
    email: {
      title: 'Qual è il tuo indirizzo e-mail per inviarti la carta regalo?',
      placeholder: 'Il tuo indirizzo e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Creare la carta regalo?',
      subtitle_one: 'Vuoi creare 1 carta regalo del valore di {{value}}?',
      subtitle_other: 'Vuoi creare {{count}} carte regalo del valore di {{value}}?',
    },
    description: {
      total: 'Totale:',
      email: 'E-Mail:',
      quantity: 'Quantità',
      amount: 'Importo',
    },
    footer: {
      cancel: 'Annulla',
      confirm: 'Conferma',
    },
  },
  buttons: {
    create: 'Crea',
  },
  toasts: {
    error: 'Creazione della carta regalo non riuscita.',
    success: 'Carta regalo creata con successo.',
  },
};
